"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnlyHistoricalAssetsPaginated = void 0;

var _react = require("react");

var _usePortalAssetsPaginated = require("./usePortalAssetsPaginated");

var _usePortalCoupledAssetsPaginated = require("./usePortalCoupledAssetsPaginated");

var _usePortalHistoricalAssetsPaginated = require("./usePortalHistoricalAssetsPaginated");

var _usePortalHistoricalCoupledAssetsPaginated = require("./usePortalHistoricalCoupledAssetsPaginated");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var useOnlyHistoricalAssetsPaginated = function useOnlyHistoricalAssetsPaginated(portalId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$enabled = options.enabled,
      enabled = _options$enabled === void 0 ? true : _options$enabled;
  var isEnabled = Boolean(portalId) && enabled;
  var assetsResult = (0, _usePortalAssetsPaginated.usePortalAssetsPaginated)(portalId, {
    enabled: isEnabled
  });
  var coupledResult = (0, _usePortalCoupledAssetsPaginated.usePortalCoupledAssetsPaginated)(portalId, {
    enabled: isEnabled
  });
  var historicalResult = (0, _usePortalHistoricalAssetsPaginated.usePortalHistoricalAssetsPaginated)(portalId, {
    enabled: isEnabled
  });
  var historicalCoupledResult = (0, _usePortalHistoricalCoupledAssetsPaginated.usePortalHistoricalCoupledAssetsPaginated)(portalId, {
    enabled: isEnabled
  });
  var assets = (0, _react.useMemo)(function () {
    var _assetsResult$data$pa, _assetsResult$data, _assetsResult$data$pa2;

    return (_assetsResult$data$pa = (_assetsResult$data = assetsResult.data) === null || _assetsResult$data === void 0 ? void 0 : (_assetsResult$data$pa2 = _assetsResult$data.pages) === null || _assetsResult$data$pa2 === void 0 ? void 0 : _assetsResult$data$pa2.flatMap(function (p) {
      return p.assets;
    })) !== null && _assetsResult$data$pa !== void 0 ? _assetsResult$data$pa : [];
  }, [assetsResult.data]);
  var coupled = (0, _react.useMemo)(function () {
    var _coupledResult$data$p, _coupledResult$data, _coupledResult$data$p2;

    return (_coupledResult$data$p = (_coupledResult$data = coupledResult.data) === null || _coupledResult$data === void 0 ? void 0 : (_coupledResult$data$p2 = _coupledResult$data.pages) === null || _coupledResult$data$p2 === void 0 ? void 0 : _coupledResult$data$p2.flatMap(function (p) {
      return p.coupledAssets;
    })) !== null && _coupledResult$data$p !== void 0 ? _coupledResult$data$p : [];
  }, [coupledResult.data]);
  var historicalAssets = (0, _react.useMemo)(function () {
    var _historicalResult$dat, _historicalResult$dat2, _historicalResult$dat3;

    return (_historicalResult$dat = (_historicalResult$dat2 = historicalResult.data) === null || _historicalResult$dat2 === void 0 ? void 0 : (_historicalResult$dat3 = _historicalResult$dat2.pages) === null || _historicalResult$dat3 === void 0 ? void 0 : _historicalResult$dat3.flatMap(function (p) {
      return p.assets;
    })) !== null && _historicalResult$dat !== void 0 ? _historicalResult$dat : [];
  }, [historicalResult.data]);
  var historicalCoupled = (0, _react.useMemo)(function () {
    var _historicalCoupledRes, _historicalCoupledRes2, _historicalCoupledRes3;

    return (_historicalCoupledRes = (_historicalCoupledRes2 = historicalCoupledResult.data) === null || _historicalCoupledRes2 === void 0 ? void 0 : (_historicalCoupledRes3 = _historicalCoupledRes2.pages) === null || _historicalCoupledRes3 === void 0 ? void 0 : _historicalCoupledRes3.flatMap(function (p) {
      return p.coupledAssets;
    })) !== null && _historicalCoupledRes !== void 0 ? _historicalCoupledRes : [];
  }, [historicalCoupledResult.data]);
  return (0, _react.useMemo)(function () {
    var currentIds = new Set([].concat(_toConsumableArray(assets.map(function (a) {
      return a.id;
    })), _toConsumableArray(coupled.map(function (a) {
      return a.id;
    }))));
    return [].concat(_toConsumableArray(historicalAssets.filter(function (a) {
      return !currentIds.has(a.id);
    })), _toConsumableArray(historicalCoupled.filter(function (a) {
      return !currentIds.has(a.id);
    })));
  }, [assets, coupled, historicalAssets, historicalCoupled]);
};

exports.useOnlyHistoricalAssetsPaginated = useOnlyHistoricalAssetsPaginated;